<div class="fw-600" [ngClass]="(viewportService?.viewport$ | async)?.isMobile ? 'text-uppercase' : 'lead no-margin selection-text-color'">
  <span *ngIf='item'>
    <span *ngIf="(viewportService?.viewport$ | async)?.isMobile">{{item.requestedQuantity}}</span>
    {{item.printName | removeQuantityFromPrintName : item.requestedQuantity}}
    <sup *ngIf="item.labelSymbol">{{item.labelSymbol}}</sup>
  </span>
  <span *ngIf='special'>{{special}}</span>
</div>
